export const timeTracking = {
  title: 'Időmérő',
  selectTask: 'Válassz feladatot',
  selectTaskPlaceholder: 'Válassz...',
  timerStarted: 'Időmérő elindítva',
  timerStopped: 'Időmérő leállítva',
  timerPaused: 'Időmérő szüneteltetve',
  timerResumed: 'Időmérő folytatva',
  start: 'Indítás',
  pause: 'Szünet',
  resume: 'Folytatás',
  paused: 'Szüneteltetve',
  totalTime: 'Összes',
  hours: 'óra',
  
  // Timer controls
  startTimer: 'Indítás',
  stopTimer: 'Leállítás',
  placeholder: 'Min dolgozol?',
  
  // Time entries list
  timeEntries: 'Időbejegyzések',
  addManual: 'Manuális hozzáadás',
  noEntries: 'Még nincs időbejegyzés',
  
  // Entry details
  billable: 'Számlázható',
  running: 'Fut',
  edit: 'Szerkesztés',
  delete: 'Törlés',
  
  // Form
  newEntry: 'Új időbejegyzés',
  editEntry: 'Időbejegyzés szerkesztése',
  description: 'Leírás',
  descriptionPlaceholder: 'Mit csináltál?',
  startTime: 'Kezdés időpontja',
  endTime: 'Befejezés időpontja',
  duration: 'Időtartam',
  billableTime: 'Számlázható idő',
  dateLabel: 'Dátum',
  
  // Buttons
  cancel: 'Mégse',
  create: 'Létrehozás',
  update: 'Frissítés',
  saving: 'Mentés...',
  
  // Delete confirmation
  deleteTitle: 'Időbejegyzés törlése',
  deleteMessage: 'Biztosan törölni szeretnéd ezt az időbejegyzést?',
  deleteWarning: 'Ez a művelet nem vonható vissza.',
  
  // Errors
  errorStartTimer: 'Időmérő indítása sikertelen',
  errorStopTimer: 'Időmérő leállítása sikertelen',
  errorDeleteEntry: 'Időbejegyzés törlése sikertelen',
  errorLoadEntries: 'Időbejegyzések betöltése sikertelen',
  errorAlreadyRunning: 'Már fut egy időmérő ennél a feladatnál',
  
  // Validation
  startRequired: 'Kezdés dátuma és ideje kötelező',
  endRequired: 'Befejezés dátuma és ideje kötelező',
  endAfterStart: 'A befejezés időpontja későbbi kell legyen, mint a kezdés',
  maxDuration: 'Az időbejegyzés nem lehet hosszabb 24 óránál',
};
